module.exports = __webpack_public_path__ + "static/img/1.7b7c680.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carruDepto/1.jpg
// module id = pNuF
// module chunks = 5